/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'text!./templates/FilterErrorView.html',
	'../../widgets/livewidget/nls/StringResources'
],
function ($, View,  FilterTemplate, stringResources) {
	'use strict';
	var FilterErrorView = View.extend({

		templateString: FilterTemplate,

		init: function(options) {
			FilterErrorView.inherited('init', this, arguments);
			this.commonView = options.commonView;
		},

		renderViewComposition: function(err) {
			return this.commonView.renderInFilterItemView().then(function(viewOptions) {
				$(viewOptions.mountNode).empty();

				var sHtml = this._generateErrorHtml(err);
				this.$el.html(sHtml);
				this.$el.appendTo(viewOptions.mountNode);
				if (this.commonView.initializeMountNodeForDropDownFilterView){
					this.commonView.initializeMountNodeForDropDownFilterView();
				}
			}.bind(this));
		},

		_generateErrorHtml: function(error) {
			return this.dotTemplate({
				title: error && error.message ? error.message : stringResources.get('errMsgFilterItemGenericTitle')
			});
		}

	});
	return FilterErrorView;
});
